(ns machtfit.stepchall.route-view
  (:require [machtfit.core :as machtfit]
            [machtfit.startpage.api-events :as api-events]
            [machtfit.stepchall.catmullrom :as catmullrom]
            [machtfit.stepchall.subs :as subs]
            [machtfit.stepchall.tooltip :as tooltip]
            [machtfit.translation :refer [t]]
            [re-frame.core :as rf]))

(def ^:private path-color "#ddd")

(rf/reg-event-db ::team-marker-clicked
  (fn [db [_ team-id]]
    (assoc-in db [:ui :stepchall :tooltip] {:id team-id
                                            :type :team-marker-tooltip})))

(defn ^:private team-marker [team]
  (let [{:keys [x y color my-team?]} team]
    [:g
     {:transform (str "translate(" x "," y ")")}
     [:circle {:on-click (comp #(rf/dispatch [::team-marker-clicked (:id team)])
                               machtfit/stop-event)
               :style {:fill "#fff"
                       :stroke color
                       :stroke-width "7px"
                       :animation (when my-team? "pulse 2s infinite")
                       :cursor "pointer"}
               :r 13}]]))

(rf/reg-event-db ::stage-marker-clicked
  (fn [db [_ num-steps]]
    (assoc-in db [:ui :stepchall :tooltip] {:num-steps num-steps
                                            :type :stage-marker-tooltip})))

(defn- stage-marker-click-handler [stage e]
  (machtfit/stop-event e)
  (rf/dispatch [::stage-marker-clicked (:num-steps stage)]))

(defn- stage-marker [{:keys [x y is-start? is-goal?] :as stage}]
  (let [on-click (partial stage-marker-click-handler stage)]
    (cond
      is-start?
      [:g {:transform (str "translate(" x "," y ")")
           :on-click on-click
           :style {:fill "white"}}
       [:path
        {:d "m 43.35322,-73.06071 a 1.299,1.299 0 0 0 -1.03569,-0.30532
                314.25979,314.25979 0 0 1 -74.186,1.32354 c -2.76736,-0.3296
                -8.153,-1.00021 -10.42256,-1.32337 a 1.30057,1.30057 0 0 0
                -1.48384,1.28748 v 27.63855 a 1.30058,1.30058 0 0 0 1.11728,1.28765 q
                1.43347,0.204 2.86831,0.39323 l 7.80729,0.93323 a 302.74064,302.74064 0
                0 0 31.99513,1.69594 302.67779,302.67779 0 0 0 31.99445,-1.69594 l
                7.80747,-0.93289 q 1.435,-0.19011 2.86881,-0.39341 a 1.30056,1.30056 0 0
                0 1.11728,-1.28765 v -27.63871 a 1.299,1.299 0 0 0 -0.44793,-0.98233 z"
         :fill "white"}]
       [:path
        {:d "m -41.81031,-80 c -1.20947,-3.32e-4 -2.190022,0.98022
                -2.18969,2.18969 v 77.551 c 0,2.9195855 4.37938,2.9195855 4.37938,0 v
                -77.551 c 3.32e-4,-1.20947 -0.98022,-2.190022 -2.18969,-2.18969 z"
         :fill "lightgrey"}]
       [:path
        {:d "m 41.81174,-80 c -1.20947,-3.32e-4 -2.190022,0.98022
                -2.18969,2.18969 v 77.551 c 0,2.9195853 4.37938,2.9195853 4.37938,0 v
                -77.551 C 44.001762,-79.01978 43.02121,-80.000332 41.81174,-80 Z"
         :fill "lightgrey"}]]

      is-goal?
      [:g {:transform (str "translate(" x "," y ")")
           :on-click on-click}
       [:polygon
        {:transform "translate(-1.403288,-74.912762)"
         :points "59.049,20 65.647,36 3.206,36 3.206,4 65.647,4 "
         :fill "#e62e73"}]
       [:path
        {:d "m 0.199762,-74.912752 a 1.60259,1.60259 0 0 0 -1.603,1.603 v
                73.1328356 a 1.603025,1.603025 0 0 0 3.20605,0 V -73.309752 a
                1.60258,1.60258 0 0 0 -1.60305,-1.603 z"
         :fill "grey"}]]

      :else
      [:g
       {:transform (str "translate(" x "," y ")")}
       [:line {:x1 1
               :y1 1
               :x2 1
               :y2 -39
               :style {:stroke-width 3
                       :stroke "#444"}}]
       [:line {:x1 0
               :y1 0
               :x2 0
               :y2 -40
               :style {:stroke-width 3
                       :stroke path-color}}]
       [:circle {:cx 1
                 :cy 1
                 :r 7
                 :style {:fill "#444"}}]
       [:circle {:cx 0
                 :cy 0
                 :r 7
                 :style {:fill path-color}}]])))

(defn- stage-marker-text [{:keys [x y is-start? is-goal? name] :as stage}]
  (let [on-click (partial stage-marker-click-handler stage)]
    (cond
      is-start?
      [:g
       {:transform (str "translate(" x "," y ")")
        :on-click on-click}
       [:text.no-select {:x 0
                         :y -45
                         :style {:font-size "30px"
                                 :fill "#222"
                                 :text-anchor "middle"
                                 :font-weight "700"}}
        [t name]]]
      is-goal?
      nil
      :else
      [:g
       {:transform (str "translate(" x "," y ")")
        :on-click on-click}
       [:text.no-select {:x 3
                         :y -47
                         :style {:font-size "30px"
                                 :fill "black"
                                 :stroke "black"
                                 :stroke-width "2px"
                                 :text-anchor "middle"
                                 :font-weight "700"}}
        [t name]]
       [:text.no-select {:x 0
                         :y -50
                         :style {:font-size "30px"
                                 :fill "white"
                                 :stroke "gray"
                                 :stroke-width "1px"
                                 :text-anchor "middle"
                                 :font-weight "700"}}
        [t name]]])))

(rf/reg-event-db ::outside-marker-clicked
  (fn [db _]
    (assoc-in db [:ui :stepchall :tooltip] nil)))

(defn stage-markers [stages-subscription]
  (into [:g.stages]
        (map (fn [stage] [stage-marker stage]))
        @(rf/subscribe stages-subscription)))

(defn stage-marker-texts [stages-subscription]
  (into [:g.stages-text]
        (map (fn [stage] [stage-marker-text stage]))
        @(rf/subscribe stages-subscription)))

(rf/reg-sub ::show-all-teams?
  :<- [::subs/count-teams]

  (fn [count-team _]
    (< count-team 50)))

(rf/reg-sub ::team-filter
  :<- [::show-all-teams?]
  :<- [:get [:ui :stepchall :route-view-filter]]

  (fn [[show-all-teams? team-filter] _]
    (let [default-team-filter (if show-all-teams? :all :team)]
      (or team-filter default-team-filter))))

(rf/reg-sub ::teams-filtered
  :<- [::subs/teams]
  :<- [::team-filter]
  :<- [:get [:stepchall :team :rank]]

  (fn [[teams team-filter own-rank] _]
    (case team-filter
      :top (concat (take 10 teams)
                   (filter :my-team? teams))
      :tail (concat (take-last 10 teams)
                    (filter :my-team? teams))
      :team (filter #(<= (- own-rank 5) (:rank %) (+ own-rank 5)) teams)
      teams)))

(defn- team-markers []
  (let [teams @(rf/subscribe [::teams-filtered])
        other-teams (remove :my-team? teams)
        my-team (first (filter :my-team? teams))]
    [:<>
     [:g.other-teams
      (doall
       (for [team other-teams]
         ^{:key (:id team)} [team-marker team]))]

     (when my-team [team-marker my-team])]))

(defn route-path [curve-subscription]
  [:path.route {:d (catmullrom/curve->svg-path @(rf/subscribe curve-subscription))
                :style {:stroke path-color}}])

(rf/reg-event-db ::interaction-clicked
  (fn [db [_ filter]]
    (assoc-in db [:ui :stepchall :route-view-filter] filter)))

(defn- interaction []
  (when (>= @(rf/subscribe [::subs/count-teams]) 15)
    (let [team-filter @(rf/subscribe [::team-filter])]
      [:div.sc_route-view-interaction {:style {:position "absolute"
                                               :top "17px"
                                               :right "16px"}}
       [:div.button-group
        [:button {:class (when (= team-filter :top) "active")
                  :on-click #(rf/dispatch [::interaction-clicked :top])}
         "Top 10"]
        (when @(rf/subscribe [::subs/is-team-member?])
          [:button {:class (when (= team-filter :team) "active")
                    :on-click #(rf/dispatch [::interaction-clicked :team])}
           "Team"])
        [:button {:class (when (= team-filter :tail) "active")
                  :on-click #(rf/dispatch [::interaction-clicked :tail])}
         (t {:de "Ende"
             :en "Tail"})]]
       (when @(rf/subscribe [::show-all-teams?])
         [:div.button-group
          [:button {:class (when (= team-filter :all) "active")
                    :on-click #(rf/dispatch [::interaction-clicked nil])}
           (t {:de "Alle"
               :en "All"})]])])))

(defn route-view []
  [:div.sc_route-view {:on-click #(rf/dispatch [::outside-marker-clicked])}
   [:img {:style {:width "100%"} :src @(rf/subscribe [:get [:stepchall :route :background-image :url]])}]
   [:svg {:id "route-svg"
          :style {:position "absolute"
                  :top 0
                  :left 0
                  :right 0
                  :width "100%"
                  :height "100%"}
          :view-box "0 0 1000 1000" :preserveAspectRatio "xMidYMin meet"}
    [route-path [::subs/catmullrom-curve]]
    [stage-markers [::subs/stages]]
    [team-markers]
    [stage-marker-texts [::subs/stages]]]
   [tooltip/own-team-tooltip]
   [tooltip/tooltip]
   [interaction]])

(rf/reg-event-fx ::navigate-to-stepchall-route
  (fn [{:keys [db]} _]
    (-> {:db db}
        (assoc-in [:db :ui :page] {:id :stepchall
                                   :subpage nil})
        (assoc :scroll-to {:frame :app-frame
                           :mode :page-top})
        (api-events/load-data-on-demand)
        (api-events/api-requests-on-stepchall-event))))
